import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const a = r((e, i) => /* @__PURE__ */ s.jsx(
  t,
  {
    ref: i,
    ...e,
    image: (o) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...o,
        children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M15.25 8.5H.75C.34 8.5 0 8.16 0 7.75S.34 7 .75 7h14.5c.41 0 .75.34.75.75s-.34.75-.75.75"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3504",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" })
            }
          )
        ]
      }
    )
  }
));
a.displayName = "AgencyMinusIcon";
export {
  a as AgencyMinusIcon,
  a as default
};
//# sourceMappingURL=index.js.map
